import React, { useEffect, useState } from 'react';
import {
  Card,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  Spinner,
} from 'reactstrap';

import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import withRouter from '../../Components/Common/withRouter';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { loginUser, idamanLogin, resetLoginFlag } from '../../slices/thunks';
import logoDark from '../../assets/images/Pertamina_Logo.png';
import logoLight from '../../assets/images/pertamina-white.svg';
import logoSm from '../../assets/images/logo-sm.png';
import { createSelector } from 'reselect';

import AuthSlider from './authCarousel';
import LoginBackground from './LoginBackground';
import LoginErrorAlert from './LoginErrorAlert';
import LoginFieldError from './LoginFieldError';

const Login = props => {
  const dispatch = useDispatch();
  const selectLayoutState = state => state;
  const loginpageData = createSelector(selectLayoutState, state => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));
  const { user, error, loading, errorMsg } = useSelector(loginpageData);
  const [userLogin, setUserLogin] = useState({});
  const [passwordShow, setPasswordShow] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(resetLoginFlag());
  }, [dispatch]);

  useEffect(() => {
    if (user && user) {
      const updatedUserData =
        process.env.REACT_APP_DEFAULTAUTH === 'firebase'
          ? user.multiFactor.user.username
          : user.username;
      const updatedUserPassword =
        process.env.REACT_APP_DEFAULTAUTH === 'firebase'
          ? ''
          : user.confirm_password;
      setUserLogin({
        username: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: userLogin.username || '',
      password: userLogin.password || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Please Enter Your User Name'),
      password: Yup.string().required('Please Enter Your Password'),
    }),
    onSubmit: async values => {
      setIsSubmitting(true);
      try {
        await dispatch(loginUser(values, props.router.navigate));
      } finally {
        setTimeout(() => {
          setIsSubmitting(false);
        }, 3000);
      }
    },
  });

  useEffect(() => {
    if (!loading) {
      setIsSubmitting(false);
    }
  }, [loading]);

  document.title = 'HYROC | Digital Hydrocarbon Procurement';
  return (
    <React.Fragment>
      <div className='login-corporate d-flex justify-content-center align-items-center min-vh-100'>
        <LoginBackground />

        {/* Jalan pulang ke landing HYROC (D-26). Di luar Container supaya
            menempel ke pojok layar seperti pada rancangan. */}
        <Link to='/' className='login-back-home'>
          <i className='ri-home-4-line' aria-hidden='true' />
          Back to Home
        </Link>

        <Container className='login-container position-relative'>
          <Row className='justify-content-center'>
            <Col xl={12} lg={12}>
              <Card className='login-card border-0 overflow-hidden'>
                <Row className='g-0'>
                  <AuthSlider />
                  <Col lg={6}>
                    <div className='login-form-panel d-flex flex-column h-100'>
                      <div className='login-form-accent' aria-hidden='true' />

                      <div className='login-hero-mobile d-lg-none position-relative'>
                        <div className='login-hero-overlay' />
                        <div className='login-hero-content p-4'>
                          <img
                            src={logoLight}
                            alt='Pertamina'
                            height='34'
                            className='mb-2'
                          />
                          <p className='login-hero-desc mb-0'>
                            HYROC — Digital Hydrocarbon Procurement
                          </p>
                        </div>
                      </div>

                      <div className='login-form-body flex-grow-1 d-flex flex-column p-lg-5 p-4'>
                        <div className='login-form-header mb-4'>
                          <div className='d-none d-lg-flex align-items-center mb-4'>
                            <img src={logoDark} alt='Pertamina' height='38' />
                          </div>
                          <h4 className='login-form-title mb-1'>
                            Welcome back
                          </h4>
                          <p className='login-form-subtitle mb-0'>
                            Sign in to your account to continue
                          </p>
                        </div>

                        <LoginErrorAlert error={error} visible={errorMsg} />

                        <Form
                          className='flex-grow-1 d-flex flex-column'
                          onSubmit={e => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                          action='#'
                        >
                          <div className='mb-3'>
                            <Label htmlFor='username' className='login-label'>
                              User Name
                            </Label>
                            <div className='input-group login-input-group'>
                              <span className='input-group-text'>
                                <i className='ri-user-3-line' />
                              </span>
                              <Input
                                name='username'
                                id='username'
                                className='form-control'
                                placeholder='Enter your username'
                                type='text'
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.username || ''}
                                invalid={
                                  validation.touched.username &&
                                  validation.errors.username
                                    ? true
                                    : false
                                }
                              />
                            </div>
                            <LoginFieldError
                              message={
                                validation.touched.username
                                  ? validation.errors.username
                                  : null
                              }
                            />
                          </div>

                          <div className='mb-3'>
                            <Label
                              className='login-label'
                              htmlFor='password-input'
                            >
                              Password
                            </Label>
                            <div className='position-relative auth-pass-inputgroup'>
                              <div className='input-group login-input-group'>
                                <span className='input-group-text'>
                                  <i className='ri-lock-2-line' />
                                </span>
                                <Input
                                  name='password'
                                  id='password-input'
                                  value={validation.values.password || ''}
                                  type={passwordShow ? 'text' : 'password'}
                                  className='form-control pe-5'
                                  placeholder='Enter your password'
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  invalid={
                                    validation.touched.password &&
                                    validation.errors.password
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              <LoginFieldError
                                message={
                                  validation.touched.password
                                    ? validation.errors.password
                                    : null
                                }
                              />
                              <button
                                className='btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none material-shadow-none login-password-toggle'
                                type='button'
                                id='password-addon'
                                onClick={() => setPasswordShow(!passwordShow)}
                                aria-label={
                                  passwordShow
                                    ? 'Hide password'
                                    : 'Show password'
                                }
                              >
                                <i
                                  className={`ri-${passwordShow ? 'eye-off' : 'eye'}-line align-middle`}
                                />
                              </button>
                            </div>
                          </div>

                          <div className='d-flex align-items-center justify-content-between mb-4'>
                            <div className='form-check mb-0'>
                              <Input
                                className='form-check-input'
                                type='checkbox'
                                value=''
                                id='auth-remember-check'
                              />
                              <Label
                                className='form-check-label login-check-label'
                                htmlFor='auth-remember-check'
                              >
                                Remember me
                              </Label>
                            </div>
                          </div>

                          <Button
                            disabled={isSubmitting || loading}
                            className='btn login-btn-primary w-100 d-flex align-items-center justify-content-center'
                            type='submit'
                          >
                            {isSubmitting ? (
                              <>
                                <Spinner size='sm' className='me-2' />
                                Logging in...
                              </>
                            ) : (
                              <>
                                <i className='ri-login-circle-line me-2' />
                                Sign In
                              </>
                            )}
                          </Button>

                          <div className='login-divider my-4'>
                            <span>or continue with</span>
                          </div>

                          <Button
                            type='button'
                            className='btn login-btn-idaman w-100 d-flex align-items-center justify-content-center'
                            onClick={e => {
                              e.preventDefault();
                              dispatch(idamanLogin());
                            }}
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <Spinner size='sm' className='me-2' />
                                Processing...
                              </>
                            ) : (
                              <>
                                <img
                                  src={logoSm}
                                  alt='Pertamina'
                                  height='22'
                                  className='me-2'
                                />
                                Login with idAMan
                              </>
                            )}
                          </Button>
                        </Form>
                      </div>

                      <div className='login-form-footer'>
                        &copy; {new Date().getFullYear()} PT Pertamina
                        (Persero). All rights reserved.
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);
